// Utilitaires de recadrage d'image

/**
 * Renvoie l'image rognée et redimensionnée à la taille cible sous forme de Blob.
 * @param {string} imageSrc - L'URL de l'image (Base64).
 * @param {Object} pixelCrop - Objet { x, y, width, height } de la zone à rogner en pixels.
 * @param {number} targetWidth - Largeur finale souhaitée (ex: 170).
 * @param {number} targetHeight - Hauteur finale souhaitée (ex: 187).
 * @returns {Promise<Blob>} Blob de l'image rognée au format PNG.
 */
export const getCroppedImg = (imageSrc, pixelCrop, targetWidth, targetHeight) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Définir la taille du canvas à la taille cible finale
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      // Dessiner l'image rognée et redimensionnée sur le canvas
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      // Exporter le canvas vers un Blob
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Canvas is empty'));
          return;
        }
        resolve(blob);
      }, 'image/png'); // Utiliser PNG car il gère bien la transparence
    };
    image.onerror = (error) => reject(error);
    image.src = imageSrc;
  });
};